// Человеческое сообщение для ошибок вызова server actions из клиента.
//
// «Server Action "…" was not found on the server» — вкладка открыта до
// деплоя, а на сервере уже новая сборка. Идентификаторы actions стабильны
// между сборками (NEXT_SERVER_ACTIONS_ENCRYPTION_KEY в infra), но если
// action переименовали/удалили, старой вкладке остаётся только обновиться.
export const STALE_APP_MESSAGE = 'Приложение обновилось - обновите страницу и повторите.'

export function isStaleActionError(e: unknown): boolean {
  const msg = e instanceof Error ? e.message : typeof e === 'string' ? e : ''
  return /server action .* was not found|failed to find server action/i.test(msg)
}

export function actionErrorMessage(e: unknown, fallback: string): string {
  if (isStaleActionError(e)) return STALE_APP_MESSAGE
  return e instanceof Error && e.message ? e.message : fallback
}
